import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <g fillRule="evenodd">
        <path
          d="M4.31058076,7.81042849 L7.85096147,11.3508335 L11.391342,7.81042849 L12.310581,8.72969191 L7.85096147,13.1892866 L3.39134195,8.72969191 L4.31058076,7.81042849 Z"
          transform="matrix(-1 0 0 1 15.70192255 4.1e-7)"
        />
        <path
          d="M4.31058076,2.81052004 L7.85096147,6.35092507 L11.391342,2.81052004 L12.310581,3.72978346 L7.85096147,8.18937813 L3.39134195,3.72978346 L4.31058076,2.81052004 Z"
          transform="matrix(-1 0 0 1 15.70192229 4.1e-7)"
        />
      </g>
    </svg>
  )
}

const ExpandIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
ExpandIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: 'var(--ow-color-primary-700)',
}
// 参数类型
ExpandIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}
export default ExpandIcon
